import React, { useEffect, useState } from 'react';
import * as Styles from './EmptyState.styles';
import useLocale from '@/hooks/useLocale';
import { Button, IconLink, SocialMediaIcons } from 'gatorcomponents';

import LeftCard from '@/media/MultiAgentsHome/left-card.png';
import MiddleCard from '@/media/MultiAgentsHome/middle-card.png';
import RightCard from '@/media/MultiAgentsHome/right-card.png';
import FullBodySnappy from '@/media/MultiAgentsHome/Snappy-full-body.png';

const EmptyState = () => {
  const { marketing: marketingLocale } = useLocale();
  const { multiAgentScreens: multiAgentScreensLocale } = marketingLocale;
  const { emptyState: emptyStateLocale } = multiAgentScreensLocale;

  const [visibleSideImage, setVisibleSideImage] = useState(false);
  const [visibleMiddleImage, setVisibleMiddleImage] = useState(false);

  useEffect(() => {
    setTimeout(() => {
      setVisibleMiddleImage(true);
    }, [500]);

    setTimeout(() => {
      setVisibleSideImage(true);
    }, [1000]);
  }, []);

  return (
    <>
      <Styles.StyledContainer>
        <Styles.TitleRow>
          <Styles.Title>
            {emptyStateLocale.firstTitle}
          </Styles.Title>

          <Button
            variant="secondary"
            size="small"
            label={emptyStateLocale.connectAccounts}
            iconLeft={<IconLink />}
            notFillSVG
          />
        </Styles.TitleRow>

        <Styles.FirstRowImageWrapper>
          <Styles.LeftImage $visible={visibleSideImage} src={LeftCard} />
          <Styles.MiddleImage $visible={visibleMiddleImage} src={MiddleCard} />
          <Styles.RightImage $visible={visibleSideImage} src={RightCard} />
        </Styles.FirstRowImageWrapper>

        <Styles.ImageDescription>
          {emptyStateLocale.imageDescription}
        </Styles.ImageDescription>

        <Styles.SecondTitle>
          {emptyStateLocale.secondTitle}
        </Styles.SecondTitle>

        <Styles.Description>
          {emptyStateLocale.description}
        </Styles.Description>

        <Styles.ButtonWrapper>
          <Styles.StyledButton>
            <Styles.IconsWrapper>
              <SocialMediaIcons icon="facebook" color="#fff" />
              <SocialMediaIcons icon="instagram" color="#fff" />
              <SocialMediaIcons icon="whatsapp" color="#fff" />
            </Styles.IconsWrapper>
            {emptyStateLocale.cta}
          </Styles.StyledButton>
        </Styles.ButtonWrapper>

        <Styles.CardsWrapper>
          <Styles.Card>
            <Styles.CardFirstRow>
              {emptyStateLocale.growFirstRow}
            </Styles.CardFirstRow>
            <Styles.CardDescription>
              {emptyStateLocale.grow}
            </Styles.CardDescription>
          </Styles.Card>

          <Styles.Card>
            <Styles.CardFirstRow>
              {emptyStateLocale.chatsFirstRow}
            </Styles.CardFirstRow>
            <Styles.CardDescription>
              {emptyStateLocale.chats}
            </Styles.CardDescription>
          </Styles.Card>

          <Styles.Card>
            <Styles.CardFirstRow>
              {emptyStateLocale.costPerClientFirstRow}
            </Styles.CardFirstRow>
            <Styles.CardDescription>
              {emptyStateLocale.costPerClient}
            </Styles.CardDescription>
          </Styles.Card>

          <Styles.Image src={FullBodySnappy} />
        </Styles.CardsWrapper>
      </Styles.StyledContainer>
    </>
  );
};

export default EmptyState;
